import * as angular from "angular";
import {IController} from "angular";

export class BringozMaxLoadComponent implements IController {

  weight: number;
  volume: number;
  numberOfItems: number;
  numberOfSpots: number;
  isRow?: boolean;

  constructor() {
  }

  $onInit() {
  }

}


angular
  .module('bringoz.admin.commons')
  .component('bringozMaxLoad', {
    bindings: {
      weight: '<',
      volume: '<',
      numberOfItems: '<',
      numberOfSpots: '<',
      isRow: '<?'
    },
    template: require('./bringoz-max-load.html').default,
    controller: BringozMaxLoadComponent
  });
